import { FormState } from '../../../state-machines/form-machine';
import {
  getFirstAvailableStep,
  WizardState,
} from '../../../state-machines/wizard-machine';
import { ComparatorStep } from '../../comparator/comparator-context';

export const firstAvailableStepSelector = ({ context }: WizardState) => {
  return getFirstAvailableStep(context.steps ?? []);
};

export const currentStepIndexSelector = ({ context }: WizardState) => {
  return context.currentStepIndex;
};

export const currentFormSelector = (state: WizardState) => {
  return state.context.currentStep?.getSnapshot();
};

export const stepsSelector = (state: WizardState): ComparatorStep[] => {
  return [
    ...(state.context.initialSteps as ComparatorStep[]),
    {
      path: '',
      name: 'global',
      fields: state.context.globalFields
        ? state.context.globalFields.map((f) => ({
            ...f,
            name: f.name.replace('global.', ''),
          }))
        : [],
    },
  ];
};

export const validatorsSelector = <S extends WizardState | FormState>(
  state: S
) => {
  return state.context.validators;
};

export const transformersSelector = <S extends WizardState | FormState>(
  state: S
) => {
  return state.context.transformers;
};
